export default __webpack_public_path__ + "static/media/p3.be2fca04.png";